import { createContext, RouterContextProvider } from "react-router-dom"

export interface TelegramContextType {
  chatId: number | null
  shareToken: string | null
}

export const TelegramContext = createContext<TelegramContextType>({ chatId: null, shareToken: null })

export const RouterContext = new RouterContextProvider()
